import { configuration } from "@/configuration";

export class Diagnostics {
    public static LogWarning(message: string): void {
        // eslint-disable-next-line
        console.warn(`[${configuration.about.titleShort.toLowerCase()}] ${message}`);
    }
}
